import { Link } from 'react-router'

import { trialDaysLeft } from '@langmail/auth-config/access'
import { useAuth } from '@langmail/shared-ui'

// Days-left strip under the app chrome while a trial runs; gone once the
// user subscribes (or the trial ends and the gate takes over).
export const TrialBanner = () => {
  const { user } = useAuth()
  const daysLeft = user ? trialDaysLeft(user) : null
  if (daysLeft === null) {
    return null
  }
  return (
    <div className="flex items-center justify-center gap-3 border-b bg-secondary px-4 py-2 text-secondary-foreground text-sm">
      <span>
        {daysLeft} day{daysLeft === 1 ? '' : 's'} left in your trial.
      </span>
      <Link className="underline" to="/subscribe">
        Subscribe
      </Link>
    </div>
  )
}
